import React from 'react';
import './SpacerBlock.css';

interface ResponsiveValue {
  default: number;
  sm?: number;
  md?: number;
  lg?: number;
}

interface SpacerBlockProps {
  block: {
    type: 'spacer';
    size?: ResponsiveValue;
  };
}

const SpacerBlock: React.FC<SpacerBlockProps> = ({ block }) => {
  // Default size configuration
  const defaultSize: ResponsiveValue = {
    default: 16,
    sm: undefined,
    md: undefined,
    lg: undefined,
  };

  const size = block.size || defaultSize;

  // Create CSS custom properties for responsive values
  const spacerStyles: React.CSSProperties = {
    '--spacer-default': `${size.default}px`,
    '--spacer-sm': size.sm ? `${size.sm}px` : `${size.default}px`,
    '--spacer-md': size.md
      ? `${size.md}px`
      : size.sm
        ? `${size.sm}px`
        : `${size.default}px`,
    '--spacer-lg': size.lg
      ? `${size.lg}px`
      : size.md
        ? `${size.md}px`
        : size.sm
          ? `${size.sm}px`
          : `${size.default}px`,
  } as React.CSSProperties;

  return (
    <div className="spacer-block" style={spacerStyles} aria-hidden="true" />
  );
};

export default SpacerBlock;
